import { CustomerTile } from "../components/CustomerTile"
import { Link, useLoaderData, useNavigate} from "react-router-dom"
import { TextField } from "../components/TextField";
import {  useEffect, useState } from "react";
import { formatCurrency, getUserId } from "../services/helpers";
import mixpanel from "../services/mixpanel";



export function HydrateFallback() {
	return <div>Loading...</div>;
  }

function renderCustomerList(customers){
	return customers.length == 0 ? <h3>No customers meet the search query</h3>
	: customers.map((customer,index)  =>  <CustomerTile key={index} customer={customer} />);
  }

export function Customers(){
const {customer_list} = useLoaderData();
const [searchFilter,setSearchFilter] = useState("");
const [memberFilter,setMemberFilter] = useState(null);
const navigate = useNavigate();

let filteredCustomers = customer_list.customers.filter((customer) =>
		(`${customer.first_name} ${customer.other_names} ${customer.last_name}`.toLowerCase().includes(searchFilter.trim().toLowerCase())
		|| customer.license_plate?.toLowerCase().includes(searchFilter.trim().toLowerCase()))
		&&  (memberFilter == null ||
  (memberFilter === 0 ? (customer.member_id != null && customer.is_membership_active === 0)/** All members ever */
    : (customer.member_id != null && customer.is_membership_active === 1))) /** Members with active memberships */
	);


	useEffect(()=>{
		mixpanel.identify(getUserId());
	},[]);


	return (
		<main id="Dashboard">
		<h1>Customers  ({filteredCustomers.length})</h1>

		<div className="row" id="page-actions">

			<TextField
				hint="Name or License Plate"
				value={searchFilter}
				onChange={(value)=>{setSearchFilter(value.target.value);}}
			/>
			<div className="row"
			style={{
				"gap" : "5px"
			}}>
				<Link onClick={(event)=>{event.preventDefault(); setMemberFilter(null)}}>All Customers </Link>
				<Link onClick={(event)=>{event.preventDefault(); setMemberFilter(1)}}>Active Members</Link>
				<Link onClick={(event)=>{event.preventDefault(); setMemberFilter(0)}}>Lifetime Members</Link>

			</div>


		</div>

		<div className="customer-list">

			{/* {renderCustomerList(filteredCustomers)} */}
			<table>
				<thead>
					<tr>
						<th>Customer Name</th>
						<th>Primary Vehicle</th>
						<th>Total Revenue</th>
						<th>Actions</th>
					</tr>

				</thead>
				<tbody>
					{filteredCustomers.map(customer =>
					<tr>
						<td className="clickable" onClick={()=>navigate(`/dashboard/members/u/${customer.uuid}/vehicles`)}>
							{`${customer.first_name} ${customer.other_names} ${customer.last_name}`}
							{customer.member_id && <span  className={`member-label ${customer.is_membership_active ? "active" : ""}`}>{customer.member_id}</span>}
						</td>
						<td className="clickable" onClick={()=>navigate(`/dashboard/vehicles/${customer.license_plate}/services`)}>
							{customer.vehicle_name ? <>{customer.vehicle_name} <small>({customer.vehicle_year})</small> {customer.license_plate}</> :<small>No Vehicle</small> }
						</td>
						<td>GHS {formatCurrency(customer.total_spend)}</td>
						<td><Link className="red-text" to={`/dashboard/members/u/${customer.uuid}/vehicles`}>Details </Link></td>
					</tr>

					)}
				</tbody>
			</table>
		</div>




		</main>
	)
}